<template>
  <div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt agree-bg">
					</section>
					<section>
						<div class="box row row_c row_jsc">
							<span><i class="xi-check"></i></span>
							<p>{{this.content}}</p>
						</div>
					</section>
				</article>
				<div class="cs-center row row_ac row_jsc b-cs">
					<span class="qa">고객센터 문의 </span>
					<span><a href="#" class="en phone">1877-5446</a></span>
				</div>
			</main>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'

export default {
  name: 'SaleAgrmCncl',
  components: {},
  data: () => ({
    AppConfig: AppConfig,
    content : '접수정보가 없습니다!',
    parms: {
      ordNum : '',      
    }

  }),
  computed: {

  },
  mounted() {

    this.eupReqAgreeInit();

   
  },
  methods: {
 
    async eupReqAgreeInit () {

      const params = {
        id : this.$route.query.id,        
      }

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/eup/eupbillreqmng/req-agree', {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {

            if (res.data.result) {
              console.log(res.data.result)
              const rs = res.data.result;
              this.content = rs.talkMobileMsg
            } else {
               this.content = '접수정보가 없습니다.'
            }
          } else {
             this.content = '통신오류입니다.'
          }
        })

    },    

  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/EupReqAgree.vue